webpackJsonp([237447353895685],{

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(35);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Breadcrumbs = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Breadcrumbs = exports.Breadcrumbs = function Breadcrumbs(_ref) {
	  var items = _ref.items;
	
	  return _react2.default.createElement(
	    "nav",
	    { className: "breadcrumbs", "aria-label": "Breadcrumb" },
	    _react2.default.createElement(
	      "ol",
	      { className: "breadcrumbs-list" },
	      _react2.default.createElement(
	        "li",
	        { className: "breadcrumbs-item" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/" },
	          "Home"
	        )
	      ),
	      items.map(function (item, index) {
	        return _react2.default.createElement(
	          "li",
	          { key: index, className: "breadcrumbs-item" },
	          _react2.default.createElement(
	            "span",
	            { className: "breadcrumbs-separator" },
	            "/"
	          ),
	          item.path ? _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: item.path },
	            item.label
	          ) : _react2.default.createElement(
	            "span",
	            { className: "breadcrumbs-current" },
	            item.label
	          )
	        );
	      })
	    )
	  );
	};

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CodeExample = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var highlightGraphQL = function highlightGraphQL(code) {
	  var keywords = ['query', 'mutation', 'subscription', 'fragment', 'on', 'type', 'interface', 'enum', 'union', 'scalar', 'input', 'extend', 'implements'];
	
	  var lines = code.split('\n');
	
	  return lines.map(function (line, lineIndex) {
	    var tokens = [];
	    var currentPos = 0;
	    var remainingLine = line;
	
	    // Process the line token by token
	    while (remainingLine.length > 0) {
	      var matched = false;
	
	      // Check for comment
	      var commentMatch = remainingLine.match(/^(#.*)/);
	      if (commentMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'comment' },
	          commentMatch[1]
	        ));
	        break;
	      }
	
	      // Check for string
	      var stringMatch = remainingLine.match(/^("(?:[^"\\]|\\.)*")/);
	      if (stringMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'string' },
	          stringMatch[1]
	        ));
	        remainingLine = remainingLine.slice(stringMatch[1].length);
	        currentPos += stringMatch[1].length;
	        matched = true;
	        continue;
	      }
	
	      // Check for variable
	      var varMatch = remainingLine.match(/^(\$\w+)/);
	      if (varMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'variable' },
	          varMatch[1]
	        ));
	        remainingLine = remainingLine.slice(varMatch[1].length);
	        currentPos += varMatch[1].length;
	        matched = true;
	        continue;
	      }
	
	      // Check for keyword
	      var keywordMatched = false;
	      for (var _iterator = keywords, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var keyword = _ref;
	
	        var keywordRegex = new RegExp('^(' + keyword + ')\\b');
	        var keywordMatch = remainingLine.match(keywordRegex);
	        if (keywordMatch) {
	          tokens.push(_react2.default.createElement(
	            'span',
	            { key: lineIndex + '-' + currentPos, className: 'keyword' },
	            keywordMatch[1]
	          ));
	          remainingLine = remainingLine.slice(keywordMatch[1].length);
	          currentPos += keywordMatch[1].length;
	          keywordMatched = true;
	          matched = true;
	          break;
	        }
	      }
	      if (keywordMatched) continue;
	
	      // Check for field name (word before { or ()
	      var fieldMatch = remainingLine.match(/^(\w+)(?=\s*[{(])/);
	      if (fieldMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'function' },
	          fieldMatch[1]
	        ));
	        remainingLine = remainingLine.slice(fieldMatch[1].length);
	        currentPos += fieldMatch[1].length;
	        matched = true;
	        continue;
	      }
	
	      // No special token, just take one character
	      tokens.push(_react2.default.createElement(
	        'span',
	        { key: lineIndex + '-' + currentPos },
	        remainingLine[0]
	      ));
	      remainingLine = remainingLine.slice(1);
	      currentPos += 1;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { key: lineIndex },
	      tokens
	    );
	  });
	};
	
	var highlightJSON = function highlightJSON(code) {
	  var lines = code.split('\n');
	
	  return lines.map(function (line, lineIndex) {
	    var tokens = [];
	    var remainingLine = line;
	    var currentPos = 0;
	
	    while (remainingLine.length > 0) {
	      // Check for property name (string before colon)
	      var propMatch = remainingLine.match(/^(\s*)"([^"]+)"(\s*:)/);
	      if (propMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos + '-ws' },
	          propMatch[1]
	        ));
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'property' },
	          '"',
	          propMatch[2],
	          '"'
	        ));
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos + '-colon' },
	          propMatch[3]
	        ));
	        remainingLine = remainingLine.slice(propMatch[0].length);
	        currentPos += propMatch[0].length;
	        continue;
	      }
	
	      // Check for string value
	      var stringMatch = remainingLine.match(/^("(?:[^"\\]|\\.)*")/);
	      if (stringMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'string' },
	          stringMatch[1]
	        ));
	        remainingLine = remainingLine.slice(stringMatch[1].length);
	        currentPos += stringMatch[1].length;
	        continue;
	      }
	
	      // Check for number
	      var numMatch = remainingLine.match(/^(-?\d+\.?\d*)/);
	      if (numMatch && remainingLine[0].match(/[\d-]/)) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'number' },
	          numMatch[1]
	        ));
	        remainingLine = remainingLine.slice(numMatch[1].length);
	        currentPos += numMatch[1].length;
	        continue;
	      }
	
	      // Check for boolean/null
	      var boolMatch = remainingLine.match(/^(true|false|null)\b/);
	      if (boolMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'keyword' },
	          boolMatch[1]
	        ));
	        remainingLine = remainingLine.slice(boolMatch[1].length);
	        currentPos += boolMatch[1].length;
	        continue;
	      }
	
	      // Regular character
	      tokens.push(_react2.default.createElement(
	        'span',
	        { key: lineIndex + '-' + currentPos },
	        remainingLine[0]
	      ));
	      remainingLine = remainingLine.slice(1);
	      currentPos += 1;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { key: lineIndex },
	      tokens
	    );
	  });
	};
	
	var highlightBash = function highlightBash(code) {
	  var lines = code.split('\n');
	  var commands = ['curl', 'echo', 'cat', 'grep', 'awk', 'sed', 'node', 'npm', 'yarn', 'git', 'docker', 'cd', 'ls', 'mkdir', 'rm', 'cp', 'mv'];
	
	  return lines.map(function (line, lineIndex) {
	    var tokens = [];
	    var remainingLine = line;
	    var currentPos = 0;
	    var isStartOfLine = true;
	
	    while (remainingLine.length > 0) {
	      // Check for comment
	      var commentMatch = remainingLine.match(/^(#.*)/);
	      if (commentMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'comment' },
	          commentMatch[1]
	        ));
	        break;
	      }
	
	      // Check for string
	      var stringMatch = remainingLine.match(/^(["'](?:[^"'\\]|\\.)*["'])/);
	      if (stringMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'string' },
	          stringMatch[1]
	        ));
	        remainingLine = remainingLine.slice(stringMatch[1].length);
	        currentPos += stringMatch[1].length;
	        isStartOfLine = false;
	        continue;
	      }
	
	      // Check for command at start
	      if (isStartOfLine || remainingLine.match(/^\s/)) {
	        var wsMatch = remainingLine.match(/^(\s+)/);
	        if (wsMatch) {
	          tokens.push(_react2.default.createElement(
	            'span',
	            { key: lineIndex + '-' + currentPos },
	            wsMatch[1]
	          ));
	          remainingLine = remainingLine.slice(wsMatch[1].length);
	          currentPos += wsMatch[1].length;
	          continue;
	        }
	
	        for (var _iterator2 = commands, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	          var _ref2;
	
	          if (_isArray2) {
	            if (_i2 >= _iterator2.length) break;
	            _ref2 = _iterator2[_i2++];
	          } else {
	            _i2 = _iterator2.next();
	            if (_i2.done) break;
	            _ref2 = _i2.value;
	          }
	
	          var cmd = _ref2;
	
	          var cmdMatch = remainingLine.match(new RegExp('^(' + cmd + ')\\b'));
	          if (cmdMatch) {
	            tokens.push(_react2.default.createElement(
	              'span',
	              { key: lineIndex + '-' + currentPos, className: 'keyword' },
	              cmdMatch[1]
	            ));
	            remainingLine = remainingLine.slice(cmdMatch[1].length);
	            currentPos += cmdMatch[1].length;
	            isStartOfLine = false;
	            continue;
	          }
	        }
	      }
	
	      // Check for flags
	      var flagMatch = remainingLine.match(/^(-+[\w-]+)/);
	      if (flagMatch) {
	        tokens.push(_react2.default.createElement(
	          'span',
	          { key: lineIndex + '-' + currentPos, className: 'variable' },
	          flagMatch[1]
	        ));
	        remainingLine = remainingLine.slice(flagMatch[1].length);
	        currentPos += flagMatch[1].length;
	        continue;
	      }
	
	      // Regular character
	      tokens.push(_react2.default.createElement(
	        'span',
	        { key: lineIndex + '-' + currentPos },
	        remainingLine[0]
	      ));
	      remainingLine = remainingLine.slice(1);
	      currentPos += 1;
	      isStartOfLine = false;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { key: lineIndex },
	      tokens
	    );
	  });
	};
	
	var CodeExample = exports.CodeExample = function CodeExample(_ref3) {
	  var title = _ref3.title,
	      code = _ref3.code,
	      _ref3$language = _ref3.language,
	      language = _ref3$language === undefined ? "graphql" : _ref3$language;
	
	  var _useState = (0, _react.useState)(false),
	      copied = _useState[0],
	      setCopied = _useState[1];
	
	  var handleCopy = function handleCopy() {
	    navigator.clipboard.writeText(code);
	    setCopied(true);
	    setTimeout(function () {
	      return setCopied(false);
	    }, 2000);
	  };
	
	  var renderHighlighted = function renderHighlighted() {
	    switch (language) {
	      case 'graphql':
	        return highlightGraphQL(code);
	      case 'json':
	        return highlightJSON(code);
	      case 'bash':
	        return highlightBash(code);
	      default:
	        return code;
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'code-example' },
	    title && _react2.default.createElement(
	      'div',
	      { className: 'code-example-title' },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'code-example-container' },
	      _react2.default.createElement(
	        'button',
	        {
	          className: 'code-example-copy-btn',
	          onClick: handleCopy,
	          'aria-label': 'Copy code'
	        },
	        copied ? "✓ Copied!" : "Copy"
	      ),
	      _react2.default.createElement(
	        'pre',
	        { className: 'code-example-pre' },
	        _react2.default.createElement(
	          'code',
	          { className: 'language-' + language },
	          renderHighlighted()
	        )
	      )
	    )
	  );
	};

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.FieldTypeExtra = exports.FieldType = undefined;
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fields = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldType = exports.FieldType = function FieldType(_ref) {
	  var field = _ref.field;
	
	  return _react2.default.createElement(
	    "span",
	    null,
	    (0, _fields.isList)(field.type) && "[",
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: (0, _fields.fieldUrlPath)(field.type), className: "object-field-type" },
	      (0, _fields.fieldName)(field.type),
	      (0, _fields.isNonNull)(field.type) && "!"
	    ),
	    (0, _fields.isList)(field.type) && "]",
	    (0, _fields.isNonNullList)(field.type) && "!"
	  );
	};
	
	var FieldTypeExtra = exports.FieldTypeExtra = function FieldTypeExtra(_ref2) {
	  var field = _ref2.field;
	
	  if (!(field.defaultValue || field.description)) return null;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "object-field-type-extra" },
	    field.defaultValue ? _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "span",
	        null,
	        "Default Value:"
	      ),
	      " ",
	      field.defaultValue
	    ) : null,
	    field.description ? _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "span",
	        null,
	        "Description:"
	      ),
	      " ",
	      field.description
	    ) : null
	  );
	};

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FieldType = __webpack_require__(37);
	
	var _CodeExample = __webpack_require__(28);
	
	var _Breadcrumbs = __webpack_require__(54);
	
	var _argumentDescriptions = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants for pagination and field generation
	var PAGINATION_ARGS = ['first', 'last', 'after', 'before'];
	var EXCLUDED_PAGINATION_ARGS = ['last', 'before', 'after'];
	
	var generateExampleQuery = function generateExampleQuery(fieldName, field, isQuery) {
	  var operation = isQuery ? "query" : "mutation";
	
	  // Generate variable declarations for operation signature
	  var getTypeName = function getTypeName(type) {
	    if (type.kind === "NON_NULL") {
	      return getTypeName(type.ofType) + "!";
	    }
	    if (type.kind === "LIST") {
	      return "[" + getTypeName(type.ofType) + "]";
	    }
	    return type.name;
	  };
	
	  // Get the root return type name
	  var getReturnTypeName = function getReturnTypeName(type) {
	    if (!type) return null;
	    if (type.kind === "NON_NULL" || type.kind === "LIST") {
	      return getReturnTypeName(type.ofType);
	    }
	    return type.name;
	  };
	
	  var returnTypeName = getReturnTypeName(field.type);
	  var isConnectionType = returnTypeName && returnTypeName.endsWith("Connection");
	
	  // Filter out conflicting pagination args - keep only 'first' for simplicity
	  var hasPaginationArgs = field.args && field.args.some(function (a) {
	    return PAGINATION_ARGS.includes(a.name);
	  });
	
	  var filteredArgs = field.args && hasPaginationArgs ? field.args.filter(function (a) {
	    return !EXCLUDED_PAGINATION_ARGS.includes(a.name);
	  }) : field.args;
	
	  // Format variables with line breaks for readability
	  var variableDeclarations = filteredArgs && filteredArgs.length > 0 ? filteredArgs.length === 1 ? "($" + filteredArgs[0].name + ": " + getTypeName(filteredArgs[0].type) + ")" : "(\n  " + filteredArgs.map(function (a) {
	    return "$" + a.name + ": " + getTypeName(a.type);
	  }).join(",\n  ") + "\n)" : "";
	
	  // Format field arguments with line breaks for readability
	  var fieldArgs = filteredArgs && filteredArgs.length > 0 ? filteredArgs.length === 1 ? "(" + filteredArgs[0].name + ": $" + filteredArgs[0].name + ")" : "(\n    " + filteredArgs.map(function (a) {
	    return a.name + ": $" + a.name;
	  }).join(",\n    ") + "\n  )" : "";
	
	  // Generate appropriate fields based on return type
	  var exampleFields = void 0;
	  if (isConnectionType) {
	    exampleFields = "edges {\n      node {\n        id\n        # Add other fields you need\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }";
	  } else {
	    exampleFields = "id\n    # Add other fields you need";
	  }
	
	  return "" + operation + variableDeclarations + " {\n  " + fieldName + fieldArgs + " {\n    " + exampleFields + "\n  }\n}";
	};
	
	var generateExampleVariables = function generateExampleVariables(field) {
	  if (!field.args || field.args.length === 0) return null;
	
	  // Filter out conflicting pagination args - keep only 'first' for simplicity
	  var hasPaginationArgs = field.args.some(function (a) {
	    return PAGINATION_ARGS.includes(a.name);
	  });
	
	  var filteredArgs = hasPaginationArgs ? field.args.filter(function (a) {
	    return !EXCLUDED_PAGINATION_ARGS.includes(a.name);
	  }) : field.args;
	
	  var variables = {};
	  filteredArgs.forEach(function (arg) {
	    var typeName = arg.type.name || arg.type.ofType && arg.type.ofType.name;
	    if (typeName === "ID") variables[arg.name] = "1";else if (typeName === "String") variables[arg.name] = "example";else if (typeName === "Int") variables[arg.name] = 1;else if (typeName === "Boolean") variables[arg.name] = true;else variables[arg.name] = {};
	  });
	
	  return JSON.stringify(variables, null, 2);
	};
	
	var Type = function Type(_ref) {
	  var _ref$pathContext = _ref.pathContext,
	      type = _ref$pathContext.type,
	      name = _ref$pathContext.name,
	      kind = _ref$pathContext.kind,
	      description = _ref$pathContext.description,
	      fields = _ref$pathContext.fields;
	
	  var isQuery = type === "QUERY";
	  var contextName = isQuery ? name.slice(0, -7) : name.slice(0, -9);
	
	  var breadcrumbItems = [{ label: isQuery ? "Queries" : "Mutations", path: null }, { label: contextName, path: null }];
	
	  return _react2.default.createElement(
	    "div",
	    { className: "page" },
	    _react2.default.createElement(
	      "section",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "section-text" },
	        _react2.default.createElement(_Breadcrumbs.Breadcrumbs, { items: breadcrumbItems }),
	        isQuery ? _react2.default.createElement(
	          "h1",
	          null,
	          contextName,
	          " Queries"
	        ) : _react2.default.createElement(
	          "h1",
	          null,
	          contextName,
	          " Mutations"
	        ),
	        description && _react2.default.createElement(
	          "p",
	          null,
	          description
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "section-example on" },
	        _react2.default.createElement(
	          "div",
	          { className: "section-example-info" },
	          "These ",
	          isQuery ? "queries" : "mutations",
	          " allow you to interact with ",
	          contextName.toLowerCase(),
	          " data."
	        )
	      )
	    ),
	    fields && fields.map(function (f) {
	      var exampleQuery = generateExampleQuery(f.name, f, isQuery);
	      var exampleVariables = generateExampleVariables(f);
	
	      return _react2.default.createElement(
	        "section",
	        { key: f.name, id: f.name },
	        _react2.default.createElement(
	          "div",
	          { className: "section-text" },
	          _react2.default.createElement(
	            "div",
	            { className: "operation-header" },
	            _react2.default.createElement(
	              "h3",
	              { className: "operation-name" },
	              f.name
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "operation-return-type" },
	              "Returns: ",
	              _react2.default.createElement(_FieldType.FieldType, { field: f })
	            )
	          ),
	          f.description && _react2.default.createElement(
	            "p",
	            { className: "operation-description" },
	            f.description
	          ),
	          f.args && f.args.length > 0 && _react2.default.createElement(
	            "div",
	            { className: "operation-arguments" },
	            _react2.default.createElement(
	              "h4",
	              null,
	              "Arguments"
	            ),
	            _react2.default.createElement(
	              "table",
	              null,
	              _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Argument"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Type"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Description"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                f.args.map(function (a) {
	                  return _react2.default.createElement(
	                    "tr",
	                    { key: a.name },
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      _react2.default.createElement(
	                        "code",
	                        { className: "arg-name" },
	                        a.name
	                      ),
	                      a.type.kind === "NON_NULL" && _react2.default.createElement(
	                        "span",
	                        { className: "required-badge" },
	                        "required"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      _react2.default.createElement(_FieldType.FieldType, { field: a })
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      a.isDeprecated && _react2.default.createElement(
	                        "span",
	                        { className: "deprecated-warning" },
	                        _react2.default.createElement(
	                          "strong",
	                          null,
	                          "DEPRECATED:"
	                        ),
	                        " ",
	                        a.deprecationReason,
	                        "\xA0"
	                      ),
	                      a.description || (0, _argumentDescriptions.generateArgumentDescription)(a.name, a.type)
	                    )
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "section-example on" },
	          _react2.default.createElement(
	            "div",
	            { className: "section-example-area" },
	            _react2.default.createElement(_CodeExample.CodeExample, {
	              title: "Example Query",
	              code: exampleQuery,
	              language: "graphql"
	            })
	          ),
	          exampleVariables && _react2.default.createElement(
	            "div",
	            { className: "section-example-area" },
	            _react2.default.createElement(_CodeExample.CodeExample, {
	              title: "Variables",
	              code: exampleVariables,
	              language: "json"
	            })
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = Type;
	module.exports = exports["default"];

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	// Predefined argument descriptions for common GraphQL field arguments
	var ARGUMENT_DESCRIPTIONS = exports.ARGUMENT_DESCRIPTIONS = {
	  // Core identifiers
	  'id': 'Unique identifier',
	  'active': 'Filter to only include active records',
	  'onlyenabled': 'Return only enabled items',
	  'deleted': 'Include deleted records in results',
	  'closed': 'Filter by closed status',
	  'done': 'Filter by completion status',
	  'declined': 'Include declined items',
	
	  // Pagination and limits
	  'limit': 'Maximum number of results to return',
	  'offset': 'Number of results to skip for pagination',
	  'after': 'Cursor for forward pagination',
	  'before': 'Cursor for backward pagination',
	
	  // Search and filtering
	  'query': 'Search query text',
	  'search': 'Search term to filter results',
	
	  // Date and time
	  'date': 'Specific date for the query',
	  'startdate': 'Start of date range',
	  'enddate': 'End of date range',
	  'start': 'Starting point for the range',
	  'end': 'Ending point for the range',
	  'datetime': 'Specific date and time',
	
	  // Contact information
	  'email': 'Email address',
	  'emails': 'List of email addresses',
	  'emailto': 'Recipient email address',
	  'emailbody': 'Content of the email message',
	  'phone': 'Phone number',
	
	  // Content and metadata
	  'name': 'Name of the resource',
	  'body': 'Main content or message body',
	  'comment': 'Comment or note text',
	  'notes': 'Additional notes or comments',
	
	  // Financial
	  'amount': 'Monetary amount',
	  'discount': 'Discount value',
	  'discountamount': 'Amount of discount to apply',
	  'discounttype': 'Type of discount (percentage or fixed amount)',
	
	  // Classification
	  'category': 'Category classification',
	  'categoryids': 'List of category IDs to filter by',
	  'type': 'Type or classification',
	  'status': 'Current status',
	  'code': 'Unique code identifier',
	
	  // System and configuration
	  'areacode': 'Telephone area code',
	  'enable': 'Enable or activate the feature',
	  'consent': 'Consent agreement status',
	  'donation': 'Donation amount or flag',
	  'document': 'Document data or file',
	  'documenttype': 'Type of document',
	  'attachments': 'List of file attachments',
	  'autorenew': 'Automatically renew on expiration',
	  'action': 'Action to perform',
	
	  // Reporting and analytics
	  'allowhistorical': 'Include historical data in results',
	  'additionalp rovideronly': 'Limit to additional providers only',
	  'breakdownbyprovider': 'Group results by provider',
	  'breakdowns': 'Breakdown categories for reporting',
	  'byinvoicedate': 'Group or filter by invoice date',
	  'agingbuckets': 'Time periods for aging analysis',
	  'asondate': 'Calculate values as of this date',
	
	  // Security and authentication
	  'currentpassword': 'User\'s current password for verification',
	
	  // Medical and clinical
	  'drawtime': 'Time when sample was drawn',
	
	  // System behavior
	  'excludechildren': 'Exclude child records from results',
	  'abortOnProbableTimeout': 'Cancel operation if timeout is likely'
	};
	
	// Veterinary-specific argument descriptions organized by category
	var VETERINARY_DESCRIPTIONS = {
	  // Patient/Client IDs
	  'patientid': 'ID of the patient',
	  'clientid': 'ID of the client (pet owner)',
	  'coownerclientid': 'ID of the co-owner client',
	  'clienttagids': 'List of client tag IDs to filter by',
	  'clientconsentid': 'ID of the client consent record',
	
	  // Appointment related
	  'appointmentid': 'ID of the appointment',
	  'apptid': 'ID of the appointment',
	  'appointmentfromid': 'Source appointment ID for rescheduling',
	  'appointmenttoid': 'Destination appointment ID for rescheduling',
	  'appointmenttypeid': 'ID of the appointment type',
	  'appointmenttypeids': 'List of appointment type IDs to filter by',
	  'apptonly': 'Include only appointment-related data',
	  'daycareonly': 'Include only daycare appointments',
	
	  // Clinical/Medical
	  'encounterid': 'ID of the clinical encounter',
	  'encountersectionname': 'Name of the encounter section',
	  'clinicalnoteid': 'ID of the clinical note',
	  'diagnosticcode': 'Diagnostic or ICD code',
	  'diagnosticcodeorglabtype': 'Organization lab type for diagnostic code',
	  'careteamid': 'ID of the care team',
	  'careteamroleid': 'ID of the care team role',
	
	  // Billing/Financial
	  'invoiceid': 'ID of the invoice',
	  'estimateid': 'ID of the estimate',
	  'creditmemoid': 'ID of the credit memo',
	  'couponid': 'ID of the coupon',
	
	  // Organization/Department
	  'departmentid': 'ID of the department',
	  'departmentids': 'List of department IDs to filter by',
	  'destinationorgdepartmentid': 'Target organization department ID for transfer',
	  'destinationrelationshipid': 'Target relationship ID for transfer',
	
	  // Boarding/Hospitalization
	  'boardgroupid': 'ID of the boarding group',
	  'boardrowid': 'ID of the boarding row',
	
	  // Communication
	  'conversationid': 'ID of the conversation thread',
	  'calllogid': 'ID of the call log entry',
	  'contactmethod': 'Preferred method of contact',
	  'enabledialpad': 'Enable phone dialpad functionality',
	
	  // Custom fields
	  'customappointmentfieldid': 'ID of the custom appointment field definition',
	  'customclientfieldid': 'ID of the custom client field definition',
	  'custompatientfieldid': 'ID of the custom patient field definition',
	
	  // Forms and consent
	  'consentformid': 'ID of the consent form',
	  'cadenceid': 'ID of the reminder cadence',
	
	  // Attachments and media
	  'attachmentid': 'ID of the file attachment',
	  'attachmentids': 'List of attachment IDs',
	  'asset': 'Media asset or file',
	  'clinicimage': 'Clinic logo or branding image',
	
	  // Time tracking
	  'clockin': 'Clock-in timestamp for timesheet',
	  'clockout': 'Clock-out timestamp for timesheet',
	  'endduedate': 'Final due date for the item',
	
	  // Entity references
	  'entity': 'Entity type or reference',
	  'entityid': 'ID of the referenced entity',
	  'entityname': 'Name of the entity',
	  'entitytagid': 'ID of the entity tag',
	  'entitytype': 'Type classification of the entity',
	  'entitytypeid': 'ID of the entity type',
	
	  // Data/input objects
	  'datum': 'Data point or value',
	  'datumidx': 'Index of the data point'
	};
	
	// Clean function to lookup veterinary descriptions
	var generateVeterinaryDescription = exports.generateVeterinaryDescription = function generateVeterinaryDescription(name) {
	  return VETERINARY_DESCRIPTIONS[name] || null;
	};
	
	// Utility to convert camelCase to readable text
	var camelToReadable = function camelToReadable(text) {
	  return text.replace(/([A-Z])/g, ' $1').trim().toLowerCase();
	};
	
	// Pattern-based description generators
	var PATTERN_GENERATORS = [{
	  condition: function condition(name, argType) {
	    return name === 'input' && argType && argType.name && argType.name.includes('Input');
	  },
	  generate: function generate(name, argType) {
	    var typeName = camelToReadable(argType.name.replace('Input', ''));
	    return 'Input data for ' + typeName + ' operation';
	  }
	}, {
	  condition: function condition(name) {
	    return name.endsWith('id');
	  },
	  generate: function generate(name) {
	    var resource = camelToReadable(name.replace(/id$/, ''));
	    return 'ID of the ' + resource;
	  }
	}, {
	  condition: function condition(name) {
	    return name.endsWith('ids');
	  },
	  generate: function generate(name) {
	    var resource = camelToReadable(name.replace(/ids$/, ''));
	    return 'List of ' + resource + ' IDs';
	  }
	}];
	
	// Clean function to generate pattern-based descriptions
	var generatePatternDescription = exports.generatePatternDescription = function generatePatternDescription(name, argType) {
	  for (var _iterator = PATTERN_GENERATORS, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var pattern = _ref;
	
	    if (pattern.condition(name, argType)) {
	      return pattern.generate(name, argType);
	    }
	  }
	  return null;
	};
	
	// Main function to generate argument descriptions
	var generateArgumentDescription = exports.generateArgumentDescription = function generateArgumentDescription(argName, argType) {
	  var name = argName.toLowerCase();
	
	  // Check predefined descriptions first
	  if (ARGUMENT_DESCRIPTIONS[name]) {
	    return ARGUMENT_DESCRIPTIONS[name];
	  }
	
	  // Check veterinary-specific patterns
	  var veterinaryDescription = generateVeterinaryDescription(name);
	  if (veterinaryDescription) {
	    return veterinaryDescription;
	  }
	
	  // Check generic patterns
	  var patternDescription = generatePatternDescription(name, argType);
	  if (patternDescription) {
	    return patternDescription;
	  }
	
	  // Final fallback
	  var readable = argName.replace(/([A-Z])/g, ' $1').trim();
	  return readable.charAt(0).toUpperCase() + readable.slice(1).toLowerCase();
	};

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var isList = exports.isList = function isList(fieldType) {
	  return fieldType.kind === "LIST" || fieldType.kind === "NON_NULL" && fieldType.ofType.kind === "LIST";
	};
	
	var isNonNull = exports.isNonNull = function isNonNull(fieldType) {
	  // For lists, indicate whether the `ofType` of each list item is non-null.
	  if (isNonNullList(fieldType)) {
	    return isNonNull(fieldType.ofType);
	  }
	  if (isList(fieldType)) {
	    return fieldType.ofType.kind === "NON_NULL";
	  }
	  return fieldType.kind === "NON_NULL";
	};
	
	var isNonNullList = exports.isNonNullList = function isNonNullList(fieldType) {
	  // As opposed to the the `ofType` of each list item, indicate whther the root
	  // list is non-null.
	  return fieldType.kind === "NON_NULL" && fieldType.ofType.kind === "LIST";
	};
	
	var fieldKind = exports.fieldKind = function fieldKind(fieldType) {
	  return fieldValue(fieldType, "kind");
	};
	
	var fieldName = exports.fieldName = function fieldName(fieldType) {
	  return fieldValue(fieldType, "name");
	};
	
	var fieldValue = function fieldValue(fieldType, valueProp) {
	  var field = displayableField(fieldType);
	  return field ? field[valueProp] : "";
	};
	
	var fieldUrlPath = exports.fieldUrlPath = function fieldUrlPath(fieldType) {
	  return "/" + fieldKind(fieldType).toLowerCase() + "/" + fieldName(fieldType);
	};
	
	var displayableField = exports.displayableField = function displayableField(fieldType) {
	  // Drill into lists, non-null fields, etc. to get the entity which we want to
	  // display. Presently we do not recurse deeply into list types. Only recurse
	  // deeper for a non-null list's `ofType`'s kind. For a list, return the
	  // `ofType`.
	  var isNonNullList = fieldType.kind === "NON_NULL" && fieldType.ofType.kind === "LIST";
	  if (isNonNullList) {
	    if (!fieldType.ofType) return null;
	    return displayableField(fieldType.ofType);
	  }
	  if (isList(fieldType)) {
	    if (!fieldType.ofType) return null;
	    return maybeNonNullDisplayableField(fieldType.ofType);
	  }
	  return maybeNonNullDisplayableField(fieldType);
	};
	
	var maybeNonNullDisplayableField = function maybeNonNullDisplayableField(fieldType) {
	  return fieldType.kind === "NON_NULL" ? fieldType.ofType : fieldType;
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-queries-js-b3f7e6d51c950fb3c54d.js